import { businessKey } from 'scenes/FinancePage/data/queryKeyFactory';

export const SA = 'SA';
export const SABusinessKey = businessKey.query(SA);

export const details = SABusinessKey.details();
export const logs = SABusinessKey.logs();
export const mutations = SABusinessKey.mutations();

export const moreInfo = mutations.moreInfo();
export const approve = mutations.approve();
export const reject = mutations.reject();
export const undo = mutations.undo();
